<h1 mat-dialog-title>ふりわけ変更</h1>
<div mat-dialog-content>
  <form class="shift-stamp-form">
    <div>
      <p>現状</p>
      <div class="current-stamp">
        <p>{{ targetDate?.getDate() }}日</p>
        <div class="shift-button-box"></div>
        <p>{{ currentDateTextShort }}</p>
        <p>{{ kindTitle[kind] }}</p>
      </div>
    </div>
    <div>
      <p>変更</p>
      <div class="shift-stamp">
        <p>{{ shiftTargetDate?.getDate() }}日</p>
        <div class="shift-button-list">
          <button class="shift-button" type="button" (click)="onInc()" [disabled]="!canInc || !editable">
            <mat-icon class="arrow-icon">arrow_upward</mat-icon>
          </button>
          <button class="shift-button" type="button" (click)="onDec()" [disabled]="!canDec || !editable">
            <mat-icon class="arrow-icon">arrow_downward</mat-icon>
          </button>
        </div>
        <p>{{ shiftDateTextShort }} </p>
        <p>{{ kindTitle[kind] }}</p>
      </div>
    </div>
    <div class="submit-button-form">
      <button type="cancel" (click)="onCancel()" mat-raised-button>Cancel</button>
      <button type="submit" (click)="onSubmit()" mat-raised-button color="primary" [disabled]="submitting || !canSubmit">変更</button>
    </div>
  </form>
</div>
